/**
 * Cabecera — hamburguesa según el espacio real
 * ---------------------------------------------------------------------------
 * El punto de corte de 1024px en `sections/header.liquid` es fijo: no sabe
 * cuántos enlaces tiene el menú. Con un menú largo, el punto de corte puede
 * llegar antes de que el menú realmente quepa, y entonces invade el buscador
 * en vez de convertirse en hamburguesa.
 *
 * Este archivo mide el ancho real con un ResizeObserver y añade la clase
 * `header--nav-overflow` a `.header` cuando el menú no cabe, lo que fuerza la
 * hamburguesa por CSS (ver `sections/header.liquid`) aunque la ventana ya sea
 * "de escritorio" según el punto de corte fijo.
 *
 * Envuelto en IIFE: el editor de temas recarga la sección y dos <script> con
 * la misma URL se ejecutan dos veces. Sin el envoltorio, las `const` del
 * ámbito global chocan y el archivo entero deja de funcionar.
 */

(() => {
  function checkOverflow(header) {
    const nav = header.querySelector('.header__nav');
    const menu = header.querySelector('.header__menu');
    if (!nav || !menu) return;

    // Si ya está en modo overflow, `.header__nav` tiene `display: none` y
    // `scrollWidth`/`clientWidth` darían 0 — una comparación con el menú
    // escondido nunca detecta que ya cabe, y el menú se quedaría en modo
    // móvil para siempre aunque la ventana se agrande después. Se quita la
    // clase antes de medir para comparar siempre contra el menú visible.
    const wasOverflowing = header.classList.contains('header--nav-overflow');
    if (wasOverflowing) header.classList.remove('header--nav-overflow');

    const overflowing = menu.scrollWidth > nav.clientWidth;
    header.classList.toggle('header--nav-overflow', overflowing);
  }

  function init(header) {
    if (header.dataset.navOverflowObserved) return;
    header.dataset.navOverflowObserved = 'true';

    const run = () => checkOverflow(header);

    const observer = new ResizeObserver(run);
    observer.observe(header);

    // Las fuentes web pueden llegar después del primer layout y cambiar el
    // ancho del texto del menú sin que cambie el tamaño de `.header` — eso no
    // dispara el ResizeObserver por sí solo.
    document.fonts?.ready?.then(run);

    run();
  }

  document.querySelectorAll('.header').forEach(init);
})();
